import { PricingVector } from "client/api-v2";

export const pricingVectorNames: Record<PricingVector, { singular: string; plural: string }> = {
  [PricingVector.Project]: { singular: "Project", plural: "Projects" },
  [PricingVector.Machine]: { singular: "Machine", plural: "Machines" },
  [PricingVector.Tenant]: { singular: "Tenant", plural: "Tenants" },
  [PricingVector.Target]: { singular: "Target", plural: "Targets" },
  [PricingVector.TaskCap]: { singular: "Task cap", plural: "Task cap" },
};
